import dayjs from 'dayjs';
import { useAvailability } from 'Modules/MultiStopWizard/Hooks/useAvailability';

import {
	isTripClosedByBookingType,
	isTripCompletelyClosedFromBookings,
	TicketsTabTrip,
} from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { devLog } from 'Util/_HumanWritten/ConsoleLogUtils';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { useIsPaxSpaceExceeded } from './useIsPaxSpaceExceeded';
import { useIsSoldOut } from './useIsSoldOut';
import { useIsVehicleSpaceExceeded } from './useIsVehicleSpaceExceeded';

export const useIsLegVisuallyDisabled = (trip: TicketsTabTrip, wizardData: BookingWizardData) => {
	const availability = useAvailability(trip);
	const isSoldOut = useIsSoldOut(wizardData.tabSelected, availability.passenger, availability.vehicle);

	const tripHasDeparted = trip.departed;
	const tripIsClosed =
		isTripClosedByBookingType(trip, wizardData.tabSelected);

	const isVehicleBooking = wizardData.tabSelected === 'vehicle';
	const exceedsAvailablePaxSpace = useIsPaxSpaceExceeded(trip.passengerSpacesAvailable, wizardData);
	const exceedsAvailableVehicleSpace = useIsVehicleSpaceExceeded(trip.vehicleSpacesAvailable, wizardData);

	const formattedDepartureTime = dayjs(trip.departureDateTime).format('HH:mm, MMM D, ddd');

	if (isSoldOut) {
		devLog(formattedDepartureTime, 'isSoldOut');
		return true;
	}

	if (tripHasDeparted) {
		devLog(formattedDepartureTime, 'tripHasDeparted');
		return true;
	}

	if (tripIsClosed) {
		devLog(formattedDepartureTime, 'tripIsClosed');
		return true;
	}

	if (exceedsAvailablePaxSpace) {
		devLog(formattedDepartureTime, 'exceedsAvailablePaxSpace');
		return true;
	}

	if (isVehicleBooking && exceedsAvailableVehicleSpace) {
		devLog(formattedDepartureTime, 'isVehicleBooking && exceedsAvailableVehicleSpace');
		return true;
	}

	return false;
};
